var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupVideoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276,
    height: 276,
    viewBox: "0 0 276 276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28707",
    "data-name": "Rectangle 28707",
    width: 276,
    height: 276,
    rx: 15,
    fill: "#fff",
    stroke: "#dedede",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25098",
    "data-name": "Rectangle 25098",
    width: 535.439,
    height: 276,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_28",
    "data-name": "Artwork 28",
    transform: "translate(-32.364 65.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49820",
    "data-name": "Group 49820",
    transform: "translate(-126.283 -65.094)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25098-3",
    "data-name": "Rectangle 25098",
    width: 535.439,
    height: 276,
    fill: "#80449f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49817",
    "data-name": "Group 49817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49816",
    "data-name": "Group 49816",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142102",
    "data-name": "Path 142102",
    d: "M557.982,97.341c-63.427-32.01-141.346-21.735-200.4,19.193-31.6,21.9-58.616,53.4-94.281,65.552-42.364,14.44-87.791-2.206-129.933-17.41S58.585,126.529-5.759,141.616V305.222H562.95Z",
    transform: "translate(0.461 -6.279)",
    fill: "#703c8b",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49819",
    "data-name": "Group 49819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49818",
    "data-name": "Group 49818",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142103",
    "data-name": "Path 142103",
    d: "M182.783,314.731c22.071-22.635,53.5-33.206,84.1-41.151s62.354-14.323,89.179-31.053c33.288-20.76,55.577-55.344,86.771-79.136a166.675,166.675,0,0,1,122.479-32.17l11.523,169.3Z",
    transform: "translate(-14.623 -10.377)",
    fill: "#62357a",
    opacity: 0.3
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupVideoBg);
export default __webpack_public_path__ + "static/media/Group_video_bg.daed05daf9a9bcef518abbf785e99162.svg";
export { ForwardRef as ReactComponent };